import { render, staticRenderFns } from "./HayaRichTextField.vue?vue&type=template&id=2c9e224a&"
import script from "./HayaRichTextField.vue?vue&type=script&lang=js&"
export * from "./HayaRichTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports